<template>
    <div class="c-looking-for">
        <div class="c-looking-for__title-wrapper">
            <div class="c-looking-for__title">
                <component
                    :is="titleTag || 'h3'"
                    class="title"
                >
                    {{ content.title }}
                </component>
                <p class="subtitle">
                    {{ content.title2 }}
                </p>
            </div>
        </div>

        <div
            v-if="$mq === 'lg' || $mq === 'xlg'"
            class="c-looking-for__content"
        >
            <div
                v-for="(album, index) in content.albums"
                :key="`looking-for-${index}`"
                class="c-looking-for__content__card"
            >
                <div class="c-looking-for__content__card__title">
                    <div class="title">
                        <component
                            :is="cardTitleTag || 'h4'"
                        >
                            {{ album.title }}
                        </component>
                    </div>
                    <div class="img">
                        <img
                            :src="album.link"
                            :alt="album.title"
                        >
                    </div>
                </div>
                <div class="c-looking-for__content__card__text">
                    <p>
                        {{ album.description }}
                    </p>
                </div>
            </div>
        </div>

        <div
            v-else
            class="c-looking-for__slide-show-wrapper"
        >
            <y-slideshow
                ref="Slideshow"
                height="auto"
                slides-per-view="1.2"
                pagination="1"
                autoplay
            >
                <y-slide
                    v-for="(album, index) in content.albums"
                    :key="`responsive-looking-for-${index}`"
                >
                    <div class="pa-4">
                        <div class="c-looking-for__content__card">
                            <div class="c-looking-for__content__card__title">
                                <div class="title">
                                    <component
                                        :is="cardTitleTag || 'h4'"
                                    >
                                        {{ album.title }}
                                    </component>
                                </div>
                                <div class="img">
                                    <img
                                        :src="album.link"
                                        :alt="album.title"
                                    >
                                </div>
                            </div>
                            <div class="c-looking-for__content__card__text">
                                <p>
                                    {{ album.description }}
                                </p>
                            </div>
                        </div>
                    </div>
                </y-slide>
            </y-slideshow>
        </div>

        <div
            v-if="content.custom && content.custom['button-link'] && content.custom['button-title']"
            class="c-looking-for__action"
        >
            <y-button
                color="primary"
                :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                :to="content.custom['button-link']"
                :href="content.custom['button-link']"
                :content="content.custom['button-title']"
                size="normal"
                flat
                no-padding
            />
        </div>
    </div>
</template>

<script>

    // Helpers
    import { isLink } from '@/helpers/helpers';
    // Components
    import { YSlide, YSlideshow } from '@groot-components/all';

    export default {
        name      : 'LookingFor',
        components: { YSlide, YSlideshow },
        props     : {
            content     : Object,
            titleTag    : String,
            cardTitleTag: String,
        },
        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
